<template>
  <ul :class="['pagination', alignmentClass]">
    <li :class="['page-item', firstClass, currentPage === 1 && 'disabled']"><button class="page-link" type="button" @click="changePage(1, $event)">{{ firstText }}</button></li>
    <li :class="['page-item', prevClass, currentPage === 1 && 'disabled']"><button class="page-link" type="button" @click="changePage(currentPage - 1, $event)">{{ prevText }}</button></li>
    <li
      v-for="item in pageItems"
      :key="item.key"
      :class="['page-item', item.ellipsis ? ellipsisClass : pageClass, item.page === currentPage && 'active', item.ellipsis && 'disabled']"
    >
      <span v-if="item.ellipsis" class="page-link">…</span>
      <button v-else class="page-link" type="button" @click="changePage(item.page!, $event)">{{ item.page }}</button>
    </li>
    <li :class="['page-item', nextClass, currentPage === totalPages && 'disabled']"><button class="page-link" type="button" @click="changePage(currentPage + 1, $event)">{{ nextText }}</button></li>
    <li :class="['page-item', lastClass, currentPage === totalPages && 'disabled']"><button class="page-link" type="button" @click="changePage(totalPages, $event)">{{ lastText }}</button></li>
  </ul>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'BPagination',
  props: {
    modelValue: { type: Number, default: undefined },
    value: { type: Number, default: undefined },
    totalRows: { type: Number, default: 0 },
    perPage: { type: Number, default: 20 },
    limit: { type: Number, default: 5 },
    align: { type: String, default: 'left' },
    firstText: { type: String, default: '先頭' },
    lastText: { type: String, default: '最後' },
    prevText: { type: String, default: '前へ' },
    nextText: { type: String, default: '次へ' },
    firstClass: { type: [String, Array, Object], default: '' },
    lastClass: { type: [String, Array, Object], default: '' },
    prevClass: { type: [String, Array, Object], default: '' },
    nextClass: { type: [String, Array, Object], default: '' },
    ellipsisClass: { type: [String, Array, Object], default: '' },
    pageClass: { type: [String, Array, Object], default: '' }
  },
  emits: ['update:modelValue', 'input', 'change', 'page-click'],
  setup(props, { emit }) {
    const totalPages = computed(() => Math.max(1, Math.ceil(props.totalRows / props.perPage)))
    const currentPage = computed(() => props.modelValue ?? props.value ?? 1)
    const alignmentClass = computed(() => props.align === 'center' ? 'justify-content-center' : props.align === 'right' ? 'justify-content-end' : '')
    const pageItems = computed(() => {
      const total = totalPages.value
      const limit = Math.max(3, props.limit)
      if (total <= limit) return Array.from({ length: total }, (_, i) => ({ key: `p${i + 1}`, page: i + 1 }))
      const inner = Math.max(1, limit - 2)
      let start = Math.max(2, currentPage.value - Math.floor(inner / 2))
      let end = Math.min(total - 1, start + inner - 1)
      start = Math.max(2, end - inner + 1)
      const items: Array<{ key: string; page?: number; ellipsis?: boolean }> = [{ key: 'p1', page: 1 }]
      if (start > 2) items.push({ key: 'left-ellipsis', ellipsis: true })
      for (let page = start; page <= end; page++) items.push({ key: `p${page}`, page })
      if (end < total - 1) items.push({ key: 'right-ellipsis', ellipsis: true })
      items.push({ key: `p${total}`, page: total })
      return items
    })
    const changePage = (page: number, event: MouseEvent) => {
      if (page < 1 || page > totalPages.value || page === currentPage.value) return
      emit('update:modelValue', page)
      emit('input', page)
      emit('change', page)
      emit('page-click', event, page)
    }
    return { totalPages, currentPage, alignmentClass, pageItems, changePage }
  }
})
</script>
